import {
  isNotNullOrEmptyString,
  notEmptyArray,
} from "@dirootie-extensions/javascript";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "taltech-styleguide";
import { Page } from "./Page";
import _ from "lodash";
import { TabList, Tab, TabPanel, Tabs } from "react-tabs";
import { PageTabedProps, TabItem, TabItemProps } from "@components-common/tabs";
import { useRouting } from "../../../hooks/use-routing.hook";
import { RouteConfig } from "@components-common/routes";
import {} from "../../tabs";
import { map, pipe } from "ramda";

/**
 * Retrieves the appropriate component based on the tab and route parameters.
 *
 * @param {TabItem} tab - The tab item containing component and optional children.
 * @param {PageTabedProps} props - The props for the tabbed page.
 * @param {Object} params - The route parameters.
 * @returns {React.ComponentType} - The component to be rendered.
 */
const getComponent = (tab: TabItem, props: PageTabedProps, params: any) => {
  if (notEmptyArray(tab.children!)) {
    if (params.actionId === undefined) {
      return tab.component;
    }
    const t = tab.children?.filter((x) => x.path === params.actionId);
    if (t!.length > 0) {
      return t![0].component;
    }
    return tab.component;
  } else {
    return tab.component;
  }
};

/**
 * Creates the properties for a tab item based on the route configuration and tab item.
 *
 * @param {RouteConfig} routeConfig - The route configuration.
 * @param {TabItem} tab - The tab item.
 * @returns {TabItemProps} - The properties for the tab item.
 */
const createTabItemProps = (
  routeConfig: RouteConfig,
  tab: TabItem
): TabItemProps => {
  console.log("descriptinoon", routeConfig.getRouteDescription());
  const { path, index, ...rest } = tab;
  const result: TabItemProps = {
    ...rest,
    index,
    component: routeConfig.getContent()!,
    path: routeConfig.buildRouteFromContext(),
  };
  console.log("path", result);
  return result;
};

/**
 * PageTabed Component
 *
 * Renders a page with tabbed navigation.
 *
 * @param {PageTabedProps} props - The props for the tabbed page component.
 * @returns {JSX.Element} - The rendered tabbed page.
 */
export const PageTabed: any = (props: PageTabedProps) => {
  const { tabs, selected = 0, pathBase, ...rest } = props;
  const history = useNavigate();
  const routingService = useRouting();
  let selectedIndex = selected;
  const tabProps: TabItemProps[] = map(
    (x) => createTabItemProps(routingService.get(x.routeId!), x),
    tabs
  );
  return (
    <Page {...rest}>
      <Container>
        <Tabs
          id="page-tabs"
          selectedIndex={selectedIndex}
          onSelect={(
            index: number,
            last: undefined | number,
            evt: Event | undefined
          ) => {
            const selectedTab = tabProps[index];
            if (selectedTab !== undefined) {
              history(selectedTab.path);
            }
            return true;
          }}
        >
          <TabList>
            {tabProps.map((x: any) => (
              <Tab>{x.label}</Tab>
            ))}
          </TabList>
          {tabProps.map((x: any) => (
            <TabPanel key={x.index + x.path}>{x.component}</TabPanel>
          ))}
        </Tabs>
      </Container>
    </Page>
  );
};
